import { DatePickerTheme, multiVariantStyles } from '../DatePickerStyles.css';
import { baseTheme } from './DatePickerBaseTheme.css';

/*******************
 * Component Theme
 *******************/

const DatePickerRedwoodTheme: DatePickerTheme = {
  baseTheme,
  multiVariantStyles
};

/*******************
 * Exports
 *******************/

export { DatePickerRedwoodTheme };
